/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import { ORG_TITLE } from "../config";

/*
 * The organisation name a donor tab falls back to (CP-431).
 *
 * Every donor page titles itself with the organisation's name, but only once
 * its own /donors/organization fetch has answered, and a handful (the PayMe,
 * Tap & Go and manual-payment pages among them) carry no title at all. Until
 * then the tab showed index.html's static "Powered by CheckPlus". Each fetch
 * that learns the name now remembers it here; routes-subdomain.js reads it
 * back as the Helmet default, and public/index.html reads the same key before
 * the bundle loads.
 *
 * No host in the key: localStorage is per origin, and each organisation's
 * subdomain or custom domain is its own origin. Storage can be unavailable
 * (private windows, blocked site data), so both sides swallow the error and
 * the tab keeps the build's fallback title.
 */
export const rememberOrgTitle = (name) => {
  if (!name) return;
  try {
    window.localStorage.setItem(ORG_TITLE, name);
  } catch (e) {
    // Storage unavailable; the fallback title stands.
  }
};

export const readOrgTitle = () => {
  try {
    return window.localStorage.getItem(ORG_TITLE) || undefined;
  } catch (e) {
    return undefined;
  }
};
